export const homeObjectOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Bank",
  headline: "Unlimited Transactions with ZERO fees",
  description:
    "Get access to our exclusive app that allows you to make unlimited transactions without charging any fees.",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../images/svg-1.svg").default,
  alt: "piggybank",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjectTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headline: "Login to your account at anytime",
  description:
    "We have you covered no matter where you're located. All you need is an internet connection and a mobile/computer.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../images/svg-22.svg").default,
  alt: "login-image",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjectThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join Our Team",
  headline: "Creating an account is extremely easy",
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information through your mobile/computer and you're ready to go.",
  buttonLabel: "Start Now",
  imgStart: false,
  img: require("../images/svg-3.svg").default,
  alt: "online-transaction",
  dark: false,
  primary: false,
  darkText: true,
};
